import { z } from 'zod';

export const groupProcessDtoSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  name: z.string(),
  color: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const groupProcessCreateSchema = z.object({
  name: z.string().min(1).max(50),
  color: z.string().min(1).max(16),
});

export const groupProcessUpdateSchema = z.object({
  name: z.string().min(1).max(50).optional(),
  color: z.string().min(1).max(16).optional(),
});

export type GroupProcessDto = z.infer<typeof groupProcessDtoSchema>;
export type GroupProcessCreateInput = z.infer<typeof groupProcessCreateSchema>;
export type GroupProcessUpdateInput = z.infer<typeof groupProcessUpdateSchema>;
